module.exports = __webpack_public_path__ + "static/img/game2.5a872f47.png";